export class XHR404Error extends Error {
  constructor(message: string) {
    super()

    this.message = message || "Данные не найдены."
  }
}
